import React from 'react';
import { useQuery } from '@apollo/client';
import styled from 'styled-components';
import Container from 'ls-common-client/dist/components/Container';
import { guidesArticlesQuery } from '../../gql/cms';
import AddABusiness from '../../components/AddABusiness';
import ScrollToTop from '../../components/ScrollToTop';
import DigitalMarketingBanner from '../../components/DigitalMarketingBanner';
import ReviewForm from '../../components/ReviewForm';
import ArticlesList from '../../components/Landing/ArticlesList';
import GuidesTop from '../../components/Landing/GuidesTop';
import GuidesHeaderBackground from '../../assets/guides/guideBackground.png';
import CategoryList from './CategoryList';
import CategorySearch from './CategorySearch';
import Meta from './Meta';

const StyledContainerRoot = styled(Container)`
  background: #ffffff;

  .AnimatedBanner__root.GuidesTop__AnimatedBanner {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }

  .Landing__Heading__root {
    padding-top: 50px;
  }

  @media (max-width: 767px) {
    .Landing__Heading__root {
      padding-top: 0;
      padding-bottom: 20px;
      text-align: center;
    }
    .Landing__GuidesTop__bannerContent .Breadcrumbs__root {
      margin-bottom: 15px;
    }
    .Landing__GuidesTop__bannerContent {
      padding-bottom: 40px;
    }
  }
`;

const StyledContainerContent = styled(Container)`
  padding-top: 40px;
  min-height: 600px;
  background-color: #f8f8f8;

  .LayoutContainer__root {
    max-width: 1220px;
  }

  @media (max-width: 1024px) {
    padding-top: 80px;
  }

  @media (max-width: 767px) {
    padding-top: 40px;
  }
`;

const Guides = () => {
  const { data } = useQuery(guidesArticlesQuery, {
    variables: {
      categorySize: 100,
    },
  });
  const { localsearchCMSArticles } = data || {};
  const { results = [], categories = [] } = localsearchCMSArticles || {};

  return (
    <StyledContainerRoot className="Guides__root">
      <ScrollToTop />
      <Meta />
      <GuidesTop
        heading="Information & Cost Guides in Australia"
        headerTransparent
        bannerImage={GuidesHeaderBackground}
        searchShow={false}
        breadcrumbs={[
          {
            breadcrumb: 'Localsearch',
            url: '/',
          },
          {
            url: '/guides',
            breadcrumb: 'Information & Cost Guides in Australia',
          },
        ]}
      >
        <CategorySearch />
      </GuidesTop>
      <StyledContainerContent className="Guides__Content">
        <CategoryList categories={categories} />
        <ArticlesList
          title="Recent Cost Guides & Information Resources"
          subHeading="Take your time and browse our extensive Localsearch Guides for hidden gems such as the cost of a kitchen benchtop, where to find a new alternator, which mulch would suit your garden the best and so much more."
          articles={results}
        />
      </StyledContainerContent>
      <DigitalMarketingBanner
        style={{
          background: '#f8f8f8',
        }}
      />
      <ReviewForm />
      <AddABusiness />
    </StyledContainerRoot>
  );
};

export default Guides;
